import {Component, Element, h, Host, Prop} from '@stencil/core';
import {PanelSizes} from '@/types';

/**
 * @slot panel-title - Title of the panel. Mandatory
 * @slot panel-title-action - CTA in top right corner. Not mandatory
 * @slot panel-subtitle - Subtitle of the panel. Not mandatory
 * @slot panel-body - All the content you need in your panel. Insert what you want here
 * @slot panel-action - If you need a CTA, use this. You can call it as many times as you need
 * */

@Component({
    tag: 'joy-panel',
    styleUrl: 'panel.scss',
    shadow: true,
})
export class JoyPanel {
    private hasHeaderSlots = false;

    @Element() host!: HTMLJoyPanelElement;

    /** Manually fix the padding you want. By default, it will use 3 sizes and automatically resize depending on screen size. **/
    @Prop({reflect: true}) padding?: PanelSizes;
    /** Remove the bottom margin set by default. Useful for responsive purpose and used in joy-template when joy-panel in a direct slot children **/
    @Prop({reflect: true}) noMargin = false;
    /** When panel is used in a wrapper, you can use this prop to set its flex-grow. **/
    @Prop({reflect: true}) flex?: string;
    /** Default to large. 2 possibles values : small or large */
    @Prop() titleSize: 'small' | 'large' = 'large';

    private get paddingStyle() {
        return this.padding ? {[`joy-panel--${this.padding}`]: true} : null;
    }

    private detectParentType() {
        const parentIsWrapper = this.host.parentElement!.tagName === 'JOY-WRAPPER';
        if (parentIsWrapper) {
            this.noMargin = true;
        }
    }

    render() {
        this.detectParentType();

        return (
            <Host style={{flex: `${this.flex}`}}>
                <section
                    class={{
                        'joy-panel': true,
                        ...this.paddingStyle,
                    }}
                    part="panel-section"
                >
                    <header
                        class={{
                            'joy-panel__header': true,
                            'joy-panel__header--slotted': this.hasHeaderSlots,
                            [`joy-panel__header--${this.titleSize}`]: true,
                        }}
                    >
                        <slot name="panel-title" />
                        <slot name="panel-title-action" />
                        <slot name="panel-subtitle" />
                    </header>
                    <div class="joy-panel__body" part="panel-body">
                        <slot name="panel-body" />
                    </div>
                    <footer class="joy-panel__footer">
                        <joy-wrapper justify="flex-end">
                            <slot name="panel-action" />
                        </joy-wrapper>
                    </footer>
                </section>
            </Host>
        );
    }
}
